module.exports = __webpack_public_path__ + "img/instagram.9a1234ff.svg";